import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';
import { getCustomTimestamp } from '@elab/core/utils/helpers';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const getAIServiceUri = (baseUrl, serviceUrl) => {
    return baseUrl + serviceUrl;
};

export const getNavigationCategoryTags = async ({ baseUrl, apiKey, categoryId, serviceUrl }) => {
    // /ai/v2/category/tag/$baseSiteId/{categoryCode}?lang=$lang
    serviceUrl = serviceUrl.replace('{categoryCode}', categoryId);
    const url = getAIServiceUri(baseUrl, serviceUrl);
    const response = await HTTPClient().get(url, {
        apiKey,
    });
    const resp = await response.json();
    if (!response) {
        // throw error if needed
    }
    return resp;
};

export const fetchRelatedKeyword = async (baseUrl, keyWord, apiKey, categoryId, serviceUrl) => {
    serviceUrl = serviceUrl.replace('{categoryCode}', categoryId);
    serviceUrl = serviceUrl.replace('{keyword}', keyWord);
    const url = getAIServiceUri(baseUrl, serviceUrl);
    const response = await HTTPClient().get(url, {
        apiKey,
    });
    const resp = await response.json();
    if (!response) {
        // throw error if needed
    }
    return resp;
};

export const getProductCodeList = async (
    baseUrl,
    keyWord,
    categoryId,
    apiKey,
    page,
    pageSize,
    serviceUrl,
) => {
    serviceUrl = serviceUrl.replace('{categoryCode}', categoryId);
    serviceUrl = serviceUrl.replace('{keyword}', keyWord);
    const url = `${getAIServiceUri(baseUrl, serviceUrl)}&currentPage=${page}&pageSize=${pageSize}`;
    const response = await HTTPClient().get(url, {
        apiKey,
    });
    const resp = await response.json();
    if (!response) {
        // throw error if needed
    }
    return resp;
};

export const getProductList = async productList => {
    productList =
        productList && productList.length > 0
            ? productList.map(item => `pid:${item}`).join(':')
            : '';
    let url = `${getApiService()}/search?fields=FULL&query=::${productList}`;

    const response = await HTTPClient().get(url);
    if (!response) {
        // throw error if needed
    }
    return await response.json();
};

export const getInterestSelectionPopupContent = async (userId, component) => {
    let url = `${getApiService()}/users/${userId || 'anonymous'}/cms/components/${component}`;

    const response = await HTTPClient().get(url);

    if (!response) {
        const { errors } = await response.json();
        throw errors;
    }
    return await response.json();
};

export const sendLastInterestSelectionTime = async () => {
    const uri = `${getApiService()}/users/current/interestselection`;
    const timeStamp = getCustomTimestamp();
    const response = await HTTPClient().putJson(uri, {
        lastInterestSelectionTime: timeStamp,
    });
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

export default { getNavigationCategoryTags, fetchRelatedKeyword };
